/**
 * @description
 * Indicator is usually only visual representation and therefore is hidden from screen readers, unless 'aria-label' property is provided.
 *
 * @specification
 * Adds role='img'.
 * Adds attribute 'aria-hidden=true' to 'root' slot.
 */
export var indicatorBehavior = function indicatorBehavior() {
  return {
    attributes: {
      root: {
        role: 'img',
        'aria-hidden': 'true'
      }
    }
  };
};
//# sourceMappingURL=indicatorBehavior.js.map
